'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { Button, Dialog, TextField } from '@/shared/components/ui';
interface CriarCalendarioDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  salvando: boolean;
  anoSugerido?: number;
  onCriar: (ano: number, importarNacionais: boolean) => Promise<boolean>;
}
const ANO_MIN = 2000;
const ANO_MAX = 2100;
export function CriarCalendarioDialog(t0) {
  const $ = _c(36);
  const {
    open,
    onOpenChange,
    salvando,
    anoSugerido,
    onCriar
  } = t0;
  const [ano, setAno] = useState("");
  const [erro, setErro] = useState(null);
  let t1;
  let t2;
  if ($[0] !== anoSugerido || $[1] !== open) {
    t1 = () => {
      if (open) {
        setAno(anoSugerido ? String(anoSugerido) : "");
        setErro(null);
      }
    };
    t2 = [open, anoSugerido];
    $[0] = anoSugerido;
    $[1] = open;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== ano || $[5] !== onCriar || $[6] !== onOpenChange) {
    t3 = async () => {
      const anoNumero = Number(ano);
      if (!Number.isInteger(anoNumero) || anoNumero < ANO_MIN || anoNumero > ANO_MAX) {
        setErro(`Informe um ano válido entre ${ANO_MIN} e ${ANO_MAX}.`);
        return;
      }
      setErro(null);
      const ok = await onCriar(anoNumero, false);
      if (ok) {
        onOpenChange(false);
      }
    };
    $[4] = ano;
    $[5] = onCriar;
    $[6] = onOpenChange;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleSalvar = t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col"><span className="text-heading-3 font-heading-3 text-default-font">Novo calendário</span><span className="text-caption font-caption text-subtext-color">O calendário deste ano alimenta o cálculo de prazos, lembretes e cobranças que vencem nele.</span></div>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = Boolean(erro);
  const t6 = erro ?? undefined;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = event => setAno(event.target.value.replace(/\D/g, "").slice(0, 4));
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== ano) {
    t8 = <TextField.Input type="number" value={ano} maxLength={4} placeholder="ex.: 2027" onChange={t7} />;
    $[10] = ano;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t6 || $[14] !== t8) {
    t9 = <TextField label="Ano" error={t5} helpText={t6}>{t8}</TextField>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== onOpenChange) {
    t10 = () => onOpenChange(false);
    $[16] = onOpenChange;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== salvando || $[19] !== t10) {
    t11 = <Button variant="neutral-secondary" onClick={t10} disabled={salvando}>Cancelar</Button>;
    $[18] = salvando;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== handleSalvar) {
    t12 = () => void handleSalvar();
    $[21] = handleSalvar;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== salvando || $[24] !== t12) {
    t13 = <Button variant="brand-primary" loading={salvando} disabled={salvando} onClick={t12}>Criar calendário</Button>;
    $[23] = salvando;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t11 || $[27] !== t13) {
    t14 = <div className="flex justify-end gap-2">{t11}{t13}</div>;
    $[26] = t11;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t14 || $[30] !== t9) {
    t15 = <Dialog.Content className="w-[460px] max-w-[95vw]"><div className="flex w-full flex-col gap-4 p-6">{t4}{t9}{t14}</div></Dialog.Content>;
    $[29] = t14;
    $[30] = t9;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== onOpenChange || $[33] !== open || $[34] !== t15) {
    t16 = <Dialog open={open} onOpenChange={onOpenChange}>{t15}</Dialog>;
    $[32] = onOpenChange;
    $[33] = open;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
}